import React from "react";
import PropTypes from "prop-types";
import { syncTitleEmployeeChanged } from "redux/organization/employeeSlice";
import SyncEmployeeConfirm from "./SyncEmployeeConfirm";

const SyncTitleEmployeeChangedConfirm = ({ showModal, setshowModal }) => (
  <SyncEmployeeConfirm
    showModal={showModal}
    setshowModal={setshowModal}
    title="Sync title employees changed"
    message="Are you sure to sync title employees changed from iHRM now?"
    action={syncTitleEmployeeChanged}
  />
);

SyncTitleEmployeeChangedConfirm.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired,
};

export default SyncTitleEmployeeChangedConfirm;
